import React, { Fragment } from "react";
import Plot from "react-plotly.js";
import { Card, CardContent, useTheme } from "@mui/material";
import IncomeChart from "components/cards/income/IncomeChart.component";
import { useTranslation } from "react-i18next";


const RadarChartPlotly = ({
    data,
    titleChart,
    yLabel,
    xLabel,
    isLoading,
    yRange,
    height = 250,
}) => {
    const theme = useTheme();
    const { i18n } = useTranslation()

    return isLoading ? (
        <IncomeChart />
    ) : (
        <Fragment>
            <Card>
                <CardContent sx={{ "&.MuiCardContent-root": { padding: 0 } }}>
                    <Plot
                        data={data}
                        useResizeHandler={true}
                        config={{ responsive: true, locale: i18n?.language ? i18n.language : 'it' }}

                        layout={{
                            font: {
                                size: 12,
                                color:
                                    theme.palette.mode === "dark" ? "white" : 'black',
                            },
                            legend: {
                                font: {
                                    size: 12,
                                    color:
                                        theme.palette.mode === "dark" ? "white" : 'black',
                                }
                            },
                            polar: {
                                barmode: "overlay",
                                bargap: 0,
                                radialaxis: { ticksuffix: "%", angle: 45, dtick: 20 },
                                angularaxis: { direction: "clockwise" },
                            },
                            margin: {
                                l: 30,
                                r: 30,
                                b: 30,
                                t: 30,
                            },

                            plot_bgcolor:
                                theme.palette.mode === "dark"
                                    ? theme.palette.background.default
                                    : "white",
                            paper_bgcolor:
                                theme.palette.mode === "dark"
                                    ? theme.palette.background.default
                                    : "white",
                            autosize: true,
                            title: titleChart,
                            titlefont: {
                                size: 16,
                                color:
                                    theme.palette.mode === "dark"
                                        ? "white"
                                        : "rgb(107, 107, 107)",
                            },
                            xaxis: {
                                title: xLabel,
                                tickfont: {
                                    size: 12,
                                    color:
                                        theme.palette.mode === "dark"
                                            ? "white"
                                            : "rgb(107, 107, 107)",
                                },
                                titlefont: {
                                    size: 12,
                                    color:
                                        theme.palette.mode === "dark"
                                            ? "white"
                                            : "rgb(107, 107, 107)",
                                },
                            },
                            yaxis: {
                                title: yLabel,
                                titlefont: {
                                    size: 11,
                                    color:
                                        theme.palette.mode === "dark"
                                            ? "white"
                                            : "rgb(107, 107, 107)",
                                },
                                tickfont: {
                                    size: 12,
                                    color:
                                        theme.palette.mode === "dark"
                                            ? "white"
                                            : "rgb(107, 107, 107)",
                                },
                                range: yRange,
                            },
                        }}
                        style={{ width: "100%", height: "100%", minHeight: height }}
                    />
                </CardContent>
            </Card>
        </Fragment>
    );
};

export default RadarChartPlotly;
